import { adt, iots, pipe, record } from '@code-expert/prelude';

const examStatusKeys = {
  closed: null,
  open: null,
  review: null,
};

export const examStatuses = pipe(examStatusKeys, record.keys);

export const foldExamStatus = adt.foldFromKeys(examStatusKeys);

export type ExamStatus = adt.TypeOfKeys<typeof foldExamStatus>;

export const ExamStatusC = iots.keyof(examStatusKeys);
